import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_collapse = _resolveComponent("a-collapse")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, {
      title: _ctx.$t('text.userInfo'),
      loading: _ctx.isLoadingInfo,
      class: "mb-20"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          "label-col": { span: 4 },
          "wrapper-col": { span: 20 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: _ctx.$t('labelText.user_name')
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.userInfo?.name), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_a_form_item, {
              label: _ctx.$t('labelText.user_email')
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.userInfo?.email || _ctx.$t('text.notUpdated')), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_a_form_item, {
              label: _ctx.$t('labelText.user_tel')
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.userInfo?.tel || _ctx.$t('text.notUpdated')), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_a_form_item, {
              label: _ctx.$t('labelText.user_coin')
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.number_format(_ctx.userInfo?.coin)), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_a_form_item, {
              label: _ctx.$t('labelText.user_promotion_coin')
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.number_format(_ctx.userInfo?.promotion_coin)), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_a_form_item, {
              label: _ctx.$t('labelText.user_point')
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.number_format(_ctx.userInfo?.point)), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_a_form_item, {
              label: _ctx.$t('labelText.created_at')
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.userInfo?.created_at), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_a_form_item, {
              label: _ctx.$t('labelText.updated_at')
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.userInfo?.updated_at), 1)
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["title", "loading"]),
    _createVNode(_component_a_card, {
      title: "Đổi thông tin bảo mật tài khoản",
      loading: _ctx.isLoadingInfo,
      class: "mb-20"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_collapse, null, {
          default: _withCtx(() => [
            (!(_ctx.userInfo && (_ctx.userInfo?.email !== null) && (_ctx.userInfo?.email?.length > 0)) || !(_ctx.userInfo && (_ctx.userInfo?.tel !== null) && (_ctx.userInfo?.tel?.length > 0)))
              ? (_openBlock(), _createBlock(_component_a_collapse_panel, {
                  key: 0,
                  header: _ctx.$t('text.updateUserInfo')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form, {
                      ref: "formInfo",
                      model: _ctx.formModelInfo,
                      onFinish: _ctx.onFinishInfo,
                      rules: _ctx.formRuleInfo,
                      scrollToFirstError: true,
                      "label-col": { span: 4 },
                      "wrapper-col": { span: 20 }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: _ctx.$t('labelText.user_email'),
                          name: "email"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _ctx.formModelInfo.email,
                              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formModelInfo.email) = $event)),
                              disabled: _ctx.userInfo && (_ctx.userInfo?.email !== null) && (_ctx.userInfo?.email?.length > 0),
                              placeholder: "some.email@gmail.com"
                            }, null, 8, ["value", "disabled"])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_a_form_item, {
                          label: _ctx.$t('labelText.user_tel'),
                          name: "tel"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _ctx.formModelInfo.tel,
                              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formModelInfo.tel) = $event)),
                              disabled: _ctx.userInfo && (_ctx.userInfo?.tel !== null) && (_ctx.userInfo?.tel?.length > 0),
                              placeholder: "0312345678"
                            }, null, 8, ["value", "disabled"])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_a_form_item, { "wrapper-col": { lg: {span: 20, offset: 4}, md: {span:24, offset: 0}} }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_button, {
                              type: "primary",
                              "html-type": "submit",
                              block: "",
                              loading: _ctx.isSavingInfo
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('text.save')), 1)
                              ]),
                              _: 1
                            }, 8, ["loading"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model", "onFinish", "rules"])
                  ]),
                  _: 1
                }, 8, ["header"]))
              : _createCommentVNode("", true),
            _createVNode(_component_a_collapse_panel, {
              header: _ctx.$t('text.updateUserPassword')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form, {
                  ref: "formPw",
                  model: _ctx.formModelPw,
                  onFinish: _ctx.onFinishPw,
                  rules: _ctx.formRulePw,
                  scrollToFirstError: true,
                  "label-col": { span: 4 },
                  "wrapper-col": { span: 20 }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: _ctx.$t('labelText.cur_password'),
                      name: "cur_password"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_password, {
                          value: _ctx.formModelPw.cur_password,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formModelPw.cur_password) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_a_form_item, {
                      label: _ctx.$t('labelText.new_password'),
                      name: "new_password"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_password, {
                          value: _ctx.formModelPw.new_password,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formModelPw.new_password) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_a_form_item, {
                      label: _ctx.$t('labelText.password_confirm'),
                      name: "password_confirm"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_password, {
                          value: _ctx.formModelPw.password_confirm,
                          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formModelPw.password_confirm) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_a_form_item, { "wrapper-col": { lg: {span: 20, offset: 4}, md: {span:24, offset: 0}} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          "html-type": "submit",
                          block: "",
                          loading: _ctx.isSavingPw
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('text.save')), 1)
                          ]),
                          _: 1
                        }, 8, ["loading"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model", "onFinish", "rules"])
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_a_collapse_panel, {
              header: "Đổi mật khẩu cấp 2",
              disabled: !_ctx.userInfo?.tel || !_ctx.userInfo?.email || (!_ctx.userInfo?.has_qa && _ctx.userInfo?.has_pw2)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form, {
                  ref: "formPw2",
                  name: "formPw2",
                  model: _ctx.formModelPw2,
                  onFinish: _ctx.onFinishPw2,
                  rules: _ctx.formRulePw2,
                  scrollToFirstError: true,
                  "label-col": { span: 4 },
                  "wrapper-col": { span: 20 }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: _ctx.$t('labelText.user_tel'),
                      name: "tel",
                      hidden: !_ctx.userInfo?.has_pw2,
                      required: _ctx.userInfo?.has_pw2
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.formModelPw2.tel,
                          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formModelPw2.tel) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 8, ["label", "hidden", "required"]),
                    _createVNode(_component_a_form_item, {
                      label: _ctx.$t('labelText.user_question') + ' hiện tại',
                      name: "question",
                      hidden: !_ctx.userInfo?.has_pw2,
                      required: _ctx.userInfo?.has_pw2
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          options: _ctx.optionsSecurityQuestion,
                          value: _ctx.formModelPw2.question,
                          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formModelPw2.question) = $event))
                        }, null, 8, ["options", "value"])
                      ]),
                      _: 1
                    }, 8, ["label", "hidden", "required"]),
                    _createVNode(_component_a_form_item, {
                      label: _ctx.$t('labelText.user_answer') + ' hiện tại',
                      name: "answer",
                      hidden: !_ctx.userInfo?.has_pw2,
                      required: _ctx.userInfo?.has_pw2
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.formModelPw2.answer,
                          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formModelPw2.answer) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 8, ["label", "hidden", "required"]),
                    _createVNode(_component_a_form_item, {
                      label: _ctx.$t('labelText.new_password'),
                      name: "password2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_password, {
                          value: _ctx.formModelPw2.password2,
                          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formModelPw2.password2) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_a_form_item, {
                      label: _ctx.$t('labelText.password_confirm'),
                      name: "password2_confirm"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_password, {
                          value: _ctx.formModelPw2.password2_confirm,
                          "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formModelPw2.password2_confirm) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_a_form_item, { "wrapper-col": { lg: {span: 20, offset: 4}, md: {span:24, offset: 0}} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          "html-type": "submit",
                          block: "",
                          loading: _ctx.isSavingPw2
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('text.save')), 1)
                          ]),
                          _: 1
                        }, 8, ["loading"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model", "onFinish", "rules"])
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_a_collapse_panel, {
              header: "Đổi câu hỏi bảo mật",
              disabled: !_ctx.userInfo?.tel || !_ctx.userInfo?.email || (!_ctx.userInfo?.has_pw2 && _ctx.userInfo?.has_qa)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form, {
                  ref: "formChangeSecureQA",
                  name: "formChangeSecureQA",
                  model: _ctx.formModelChangeSecureQA,
                  onFinish: _ctx.onFinishChangeSecureQA,
                  rules: _ctx.formRuleChangeSecureQA,
                  scrollToFirstError: true,
                  "label-col": { span: 4 },
                  "wrapper-col": { span: 20 }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: _ctx.$t('labelText.user_tel'),
                      name: "tel",
                      hidden: !_ctx.userInfo?.has_qa,
                      required: _ctx.userInfo?.has_qa
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.formModelChangeSecureQA.tel,
                          "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formModelChangeSecureQA.tel) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 8, ["label", "hidden", "required"]),
                    _createVNode(_component_a_form_item, {
                      label: _ctx.$t('labelText.password2'),
                      name: "password2",
                      hidden: !_ctx.userInfo?.has_qa,
                      required: _ctx.userInfo?.has_qa
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_password, {
                          value: _ctx.formModelChangeSecureQA.password2,
                          "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formModelChangeSecureQA.password2) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 8, ["label", "hidden", "required"]),
                    _createVNode(_component_a_form_item, {
                      label: _ctx.$t('labelText.user_question') + ' mới',
                      name: "question"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          options: _ctx.optionsSecurityQuestion,
                          value: _ctx.formModelChangeSecureQA.question,
                          "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formModelChangeSecureQA.question) = $event))
                        }, null, 8, ["options", "value"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_a_form_item, {
                      label: _ctx.$t('labelText.user_answer') + ' mới',
                      name: "answer"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.formModelChangeSecureQA.answer,
                          "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formModelChangeSecureQA.answer) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_a_form_item, { "wrapper-col": { lg: {span: 20, offset: 4}, md: {span:24, offset: 0}} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          "html-type": "submit",
                          block: "",
                          loading: _ctx.isSavingChangeSecureQA
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('text.save')), 1)
                          ]),
                          _: 1
                        }, 8, ["loading"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model", "onFinish", "rules"])
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_a_collapse_panel, {
              header: "Đổi email và số điện thoại",
              disabled: !_ctx.userInfo?.has_pw2 || !_ctx.userInfo?.has_qa || !_ctx.userInfo?.email?.length || !_ctx.userInfo?.tel?.length
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form, {
                  ref: "formChangeAllSecureInfo",
                  name: "formChangeAllSecureInfo",
                  model: _ctx.formModelChangeAllSecureInfo,
                  onFinish: _ctx.onFinishChangeAllSecureInfo,
                  rules: _ctx.formRuleChangeAllSecureInfo,
                  scrollToFirstError: true,
                  "label-col": { span: 4 },
                  "wrapper-col": { span: 20 }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: _ctx.$t('labelText.password2') + ' hiện tại',
                      name: "cur_password2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_password, {
                          value: _ctx.formModelChangeAllSecureInfo.cur_password2,
                          "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formModelChangeAllSecureInfo.cur_password2) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_a_form_item, {
                      label: _ctx.$t('labelText.user_question') + ' hiện tại',
                      name: "cur_question"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          options: _ctx.optionsSecurityQuestion,
                          value: _ctx.formModelChangeAllSecureInfo.cur_question,
                          "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formModelChangeAllSecureInfo.cur_question) = $event))
                        }, null, 8, ["options", "value"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_a_form_item, {
                      label: _ctx.$t('labelText.user_answer') + ' hiện tại',
                      name: "cur_answer"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.formModelChangeAllSecureInfo.cur_answer,
                          "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formModelChangeAllSecureInfo.cur_answer) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_a_form_item, {
                      label: _ctx.$t('labelText.user_email') + ' hiện tại',
                      name: "cur_email"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.formModelChangeAllSecureInfo.cur_email,
                          "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formModelChangeAllSecureInfo.cur_email) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_a_form_item, {
                      label: _ctx.$t('labelText.user_tel') + ' hiện tại',
                      name: "cur_tel"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.formModelChangeAllSecureInfo.cur_tel,
                          "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formModelChangeAllSecureInfo.cur_tel) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_a_form_item, {
                      label: _ctx.$t('labelText.user_email') + ' mới',
                      name: "email"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.formModelChangeAllSecureInfo.email,
                          "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formModelChangeAllSecureInfo.email) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_a_form_item, {
                      label: _ctx.$t('labelText.user_tel') + ' mới',
                      name: "tel"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.formModelChangeAllSecureInfo.tel,
                          "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formModelChangeAllSecureInfo.tel) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_a_form_item, { "wrapper-col": { lg: {span: 20, offset: 4}, md: {span:24, offset: 0}} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          "html-type": "submit",
                          block: "",
                          loading: _ctx.isSavingChangeAllSecureInfo
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('text.save')), 1)
                          ]),
                          _: 1
                        }, 8, ["loading"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model", "onFinish", "rules"])
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["loading"])
  ]))
}